import styled from "styled-components";
import { responsive } from "../../theme/reponsive";

export const IconWrapper = styled.div`
   position: absolute;
   right: 2rem;
   margin-top: 3rem;
   cursor: pointer;
   transition: all 0.5s;

   ${responsive("$small")`
   margin-top: 3.5rem;
`}

   &:hover {
      transform: scale(1.2);
      transition: all 0.5s;
   }
`;
